<div
  class="tw-pt-5"
  rvSpinner="purchase-add-on-loader"
  [rvShowSpinner]="purchaseService.loading || taxExemptionService.loading"
>
  @if (purchaseStepsService.currentStep === 0) {
    @switch (purchaseIntent) {
      @case ('ai-credits') {
        <purchase-ai-credits />
      }
      @case ('interactive') {
        <purchase-interactive-license />
      }
    }
  }
  @if (purchaseStepsService.currentStep === 1) {
    <billing-address></billing-address>
  }
  @if (purchaseStepsService.currentStep === 2) {
    <payment-methods></payment-methods>
  }
  @if (purchaseStepsService.currentStep === 3) {
    <checkout-success (closeEvent)="close()"></checkout-success>
  }

  <div class="mt-5 border-top">
    <purchase-footer></purchase-footer>
  </div>
</div>
